import { useCallback, useState, useContext, useEffect, Suspense } from "react";
import {
  getEmployeeRequestDefaultAssignment,
  addEmployeeRequestDefaultAssignment,
  deleteEmployeeRequestDefaultAssignment,
} from "../TicketManagement/TicketService";
import { TostMsg } from "../../../App";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
import { useParams } from "react-router-dom/cjs/react-router-dom";
import { debounce } from "lodash";
import { InputText } from "primereact/inputtext";
import { GetMasterTypeData } from "../../../Services/Global-Services/GlobalServices";
import { Dropdown } from "primereact/dropdown";
import { getEmployeeList } from "../EmployeeList/Service/employeeService";
import { LazyImage } from "../../../Services/Decorator_Lazy_Loading/ImageVideoLazyLoding";
import { useFormik } from "formik";
import ComponentLoader from "../../../Shared/Sidebar/ComponentLoader";

let employeeId;
const EmployeeRequestDefaultAssignment = () => {
  const [columns, setColumns] = useState([
    "Category Name",
    "SubCategory Name",
    "Default Assignment",
  ]); // Columns state
  const [rows, setRows] = useState([{}]); // Rows state
  const [editIndex, setEditIndex] = useState(null);
  const [empReqDefaultAssignment, setEmpReqDefaultAssignment] = useState([]);
  const defaultImage = "/images/placeholder_profile.png";
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");

  const [empReqDefaultAssignmentId, setEmpReqDefaultAssignmentId] =
    useState(null);
  const [isLoading, setIsloading] = useState(false);

  const [employeeList, setEmployeeList] = useState([]);
  const { GUID } = useParams();

  const [ticketSubcategoryType, setTicketSubcategoryType] = useState([]);
  const [ticketCategoryType, setTicketCategoryType] = useState([]);
  let toster = useContext(TostMsg);
  const [errors, setErrors] = useState({});
  const [ticketSubcategoryList, setTicketSubcategoryTypeList] = useState([]);

  useEffect(() => {
    getMasterTicketCategory();
    getMasterTicketSubCategory();
    getEmployeeIdData();
    GetEmpReqDefaultAssignment();
  }, []);

  async function GetEmpReqDefaultAssignment() {
    setIsloading(true);
    try {
      let responce = await getEmployeeRequestDefaultAssignment();
      setEmpReqDefaultAssignment(responce?.Data);
      setIsloading(false);
    } catch (err) {
      setIsloading(false);
      toster.current.error(ERROR_LIST.DefaultError);
    } finally {
      setIsloading(false);
    }
  }

  async function getMasterTicketCategory() {
    const params = {
      organisationId: userDetails?.OrgId,
      masterType: "Category",
    };
    setIsloading(true);
    try {
      const data = await GetMasterTypeData(params);
      setTicketCategoryType(data?.Data);
      setIsloading(false);
    } catch (error) {
      setIsloading(false);
    }
  }

  async function getMasterTicketSubCategory() {
    const params = {
      organisationId: userDetails?.OrgId,
      masterType: "Subcategory",
    };
    setIsloading(true);
    try {
      const data = await GetMasterTypeData(params);
      setTicketSubcategoryTypeList(data?.Data);
      setIsloading(false);
    } catch (error) {
      toster.current.error(ERROR_LIST?.MasterDataType);
      setIsloading(false);
    }
  }

  async function getEmployeeIdData() {
    var params = {
      OrganisationId: userDetails?.OrgId,
      LoggedInEmployeeId: userDetails?.EmpId,
      IsDirectReportOrHierarchy: 0,
      SearchText: "",
      FollowersOnly: 0,
      FollowingsOnly: 0,
      IsExEmployeesAlso: 0,
      pageNumber: 1,
      pageSize: 10000,
      EmployeeId: 0,
      IsSuggestedOnly: 0,
    };
    try {
      let employeesList = await getEmployeeList(params);
      setEmployeeList(employeesList.Data);
    } catch (error) {}
  }

  const employeeOptionTemplate = (option) => {
    return (
      <div className="flex align-items-center gap-2 ticket-file-attach__items_detail">
        <LazyImage
          alt={option.FullName}
          src={option.ProfileImage}
          width="50"
          height="50"
        />
        <span>{option.FullName}</span>
      </div>
    );
  };

  const handleAddRow = () => {
    EmpRequestDefaultAssignmentForm.resetForm();
    setEmpReqDefaultAssignment([
      ...empReqDefaultAssignment,
      { CategoryId: "", SubCategoryId: "", DefaultAssignment: "" , Id: 0},
    ]);
    setEditIndex(empReqDefaultAssignment.length);
  };

  const cancelOrgWfh = () => {
    setEmpReqDefaultAssignment((prevList) => {
      if (
        editIndex === null ||
        editIndex < 0 ||
        editIndex === empReqDefaultAssignment.length
      ) {
        const lastItem = prevList[prevList.length - 1];
        lastItem.CategoryId = "";
        lastItem.SubCategoryId = "";
        lastItem.DefaultAssignment = "";
        return prevList.slice(0, -1);
      }
      const item = prevList[editIndex];
      const isEmpty =
        !item?.SubCategoryId?.toString().trim() &&
        !item?.CategoryId?.toString().trim() &&
        !item?.DefaultAssignment?.toString().trim() && item?.Id === 0;
      if (isEmpty || item.Id === 0) {
        const updated = [...prevList];
        updated.splice(editIndex, 1);
        return updated;
      }
      if (item?.Id > 0) {
        GetEmpReqDefaultAssignment();
      }

      return prevList;
    });
    EmpRequestDefaultAssignmentForm.resetForm();
    setEditIndex(null);
  };

  const validateRequestDefaultAssign = (data, index) => {
    const newErrors = {};
    if (!data.CategoryId || data.CategoryId.toString().trim() === "") {
      newErrors[`${index}-CategoryId`] = "Category is required";
    }
    if (!data.SubCategoryId || data.SubCategoryId.toString().trim() === "") {
      newErrors[`${index}-SubCategoryId`] = "Sub Category is required";
    }
    if (
      !data.DefaultAssignment ||
      data.DefaultAssignment.toString().trim() === ""
    ) {
      newErrors[`${index}-DefaultAssignment`] = "Employee is required";
    }
    setErrors((prev) => {
      const filteredErrors = Object.fromEntries(
        Object.entries(prev).filter(([key]) => !key.startsWith(`${index}-`))
      );
      return { ...filteredErrors, ...newErrors };
    });

    return Object.keys(newErrors).length === 0;
  };

  const EmpRequestDefaultAssignmentForm = useFormik({
    initialValues: {
      CreatedDate: "",
      SubCategoryId: "",
      CategoryId: "",
      DefaultAssignment: "",
      Id: "",
    },
    onSubmit: async (data) => {
      setIsloading(true);
      const body = {
        Id: data?.Id || 0,
        GUID: GUID,
        IsActive: true,
        CreatedDate: data.CreatedDate || new Date().toISOString(),
        ModifiedDate: new Date().toISOString(),
        CreatedBy: 0,
        ModifiedBy: 0,
        OrgId: userDetails?.OrgId,
        CategoryId: data?.CategoryId,
        SubCategoryId: data?.SubCategoryId,
        CategoryName: "",
        defaultAssignmentName: "",
        SubCategoryName: "",
        DefaultAssignment: data?.DefaultAssignment,
      };
      try {
        await addEmployeeRequestDefaultAssignment(body);
        if (data.Id) {
          setEditIndex(null);
        } else {
          setEditIndex(null);
        }
        setTimeout(() => {
          GetEmpReqDefaultAssignment();
        }, 1000);
        setIsloading(false);
      } catch (error) {
        setIsloading(false);
      }
    },
  });

  const handleEditClick = (index) => {
    setEditIndex(index);
    const item = empReqDefaultAssignment[index];
    EmpRequestDefaultAssignmentForm.setValues({
      CategoryId: item.CategoryId || "",
      SubCategoryId: item.SubCategoryId || "",
      DefaultAssignment: item.DefaultAssignment || "",
      Id: item.Id || 0
    });
    const filteredSubcategoryList = ticketSubcategoryList.filter(
      (subcategory) => {
        return String(subcategory.CategoryId) === String(item.CategoryId);
      }
    );
    setTicketSubcategoryType(filteredSubcategoryList);
  };

  const handleEmpReqCategory = (Id) => {
    setEmpReqDefaultAssignmentId(Id);
  };

  async function DeleteOrgEmpRequestDefaultAssignment() {
    setIsloading(true);
    if (empReqDefaultAssignmentId) {
      let body = {
        Id: empReqDefaultAssignmentId,
      };
      try {
        let empReqCategoryList = await deleteEmployeeRequestDefaultAssignment(
          body
        );
        if (empReqCategoryList) {
          setIsloading(false);
          GetEmpReqDefaultAssignment();
        }
      } catch (error) {
        setIsloading(false);
        toster.current.error(ERROR_LIST.DefaultError);
      }
    }
  }

  const handleInputChange = (event) => {
    debouncedSearch(event.target.value);
  };

  const debouncedSearch = useCallback(
    debounce((value) => {
      if (value) {
        setEmpReqDefaultAssignment((prev) =>
          prev.filter(
            (item) =>
              item.CategoryName?.toLowerCase().includes(value.toLowerCase()) ||
              item.SubCategoryName?.toLowerCase().includes(
                value.toLowerCase()
              ) ||
              item.defaultAssignmentName
                ?.toLowerCase()
                .includes(value.toLowerCase())
          )
        );
      } else {
        GetEmpReqDefaultAssignment();
      }
    }, 100),
    []
  );

  async function onChangeCategoryType(e) {
    const selectedCategoryId = e?.value;

    if (!selectedCategoryId) return;

    EmpRequestDefaultAssignmentForm.setFieldValue(
      "CategoryId",
      selectedCategoryId
    );

    if (!Array.isArray(ticketSubcategoryList)) return;
    const filteredSubcategoryList = ticketSubcategoryList.filter(
      (subcategory) => {
        return String(subcategory.CategoryId) === String(selectedCategoryId);
      }
    );
    setTicketSubcategoryType(filteredSubcategoryList);
  }

  return (
    <div className="setting-detail-list">
      <div className="detail award-detail">
        <div className="input-group search-area2 d-xl-inline-flex mb-3 me-4"></div>
        <div className="title-text">
          <h3>
            Employee Request Default Assignment (
            {empReqDefaultAssignment?.length})
          </h3>
          <div className="d-flex">
            <InputText
              name="requestTitle"
              className="form-control search-grpname me-2"
              onChange={handleInputChange}
              placeholder="Search"
            />

            {!editIndex && (
              <button
                className="addaward-btn"
                data-toggle="tooltip"
                data-placement="top"
                title=""
                data-bs-original-title=""
                fdprocessedid="izng1j"
                onClick={handleAddRow}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  className="bi bi-plus"
                  viewBox="0 0 16 16"
                >
                  <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"></path>
                </svg>
                Default Assignment
              </button>
            )}
          </div>
        </div>
        <div className="col-md-12 column">
          <table className="table table-bordered table-hover" id="tab_logic">
            <thead>
              <tr>
                {columns.map((colName, colIdx) => (
                  <th key={colIdx} className="text-left">
                    {colName}
                  </th>
                ))}
                <th className="text-left" style={{ width: "100px" }}>
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {empReqDefaultAssignment?.map((data, index) => (
                <tr key={index}>
                  {editIndex === index ? (
                    <>
                      <td>
                        <Dropdown
                          value={
                            EmpRequestDefaultAssignmentForm.values.CategoryId
                          }
                          options={ticketCategoryType}
                          onChange={(e) => {
                            onChangeCategoryType(e);
                            const updatedList = [...empReqDefaultAssignment];
                            updatedList[index].CategoryId = e.value;
                            setEmpReqDefaultAssignment(updatedList);

                            EmpRequestDefaultAssignmentForm.setFieldTouched(
                              `empReqDefaultAssignment.${index}.CategoryId`,
                              true
                            );
                            validateRequestDefaultAssign(
                              updatedList[index],
                              index
                            );
                          }}
                          className="filledannoucement w-100"
                          optionLabel="Name"
                          optionValue="Id"
                          filter={true}
                          placeholder="Choose..."
                          checkmark={true}
                          highlightOnSelect={false}
                        />
                        {errors[`${index}-CategoryId`] && (
                          <div className="invalid-feedback">
                            {errors[`${index}-CategoryId`]}
                          </div>
                        )}
                      </td>

                      <td>
                        <Dropdown
                          value={
                            EmpRequestDefaultAssignmentForm.values.SubCategoryId
                          }
                          options={ticketSubcategoryType}
                          onChange={(e) => {
                            EmpRequestDefaultAssignmentForm.setFieldValue(
                              "SubCategoryId",
                              e.value
                            );
                            const updatedList = [...empReqDefaultAssignment];
                            updatedList[index].SubCategoryId = e.value;
                            setEmpReqDefaultAssignment(updatedList);

                            EmpRequestDefaultAssignmentForm.setFieldTouched(
                              `empReqDefaultAssignment.${index}.SubCategoryId`,
                              true
                            );
                            validateRequestDefaultAssign(
                              updatedList[index],
                              index
                            );
                          }}
                          className="filledannoucement w-100"
                          optionLabel="Name"
                          optionValue="Id"
                          filter={true}
                          placeholder="Choose..."
                          checkmark={true}
                          highlightOnSelect={false}
                        />
                        {errors[`${index}-SubCategoryId`] && (
                          <div className="invalid-feedback">
                            {errors[`${index}-SubCategoryId`]}
                          </div>
                        )}
                      </td>

                      <td>
                        <Dropdown
                          value={
                            EmpRequestDefaultAssignmentForm.values
                              .DefaultAssignment
                          }
                          options={employeeList}
                          onChange={(e) => {
                            EmpRequestDefaultAssignmentForm.setFieldValue(
                              "DefaultAssignment",
                              e.value
                            );
                            const updatedList = [...empReqDefaultAssignment];
                            updatedList[index].DefaultAssignment = e.value;
                            setEmpReqDefaultAssignment(updatedList);

                            EmpRequestDefaultAssignmentForm.setFieldTouched(
                              `empReqDefaultAssignment.${index}.DefaultAssignment`,
                              true
                            );
                            validateRequestDefaultAssign(
                              updatedList[index],
                              index
                            );
                          }}
                          className="filledannoucement w-100"
                          optionLabel="FullName"
                          optionValue="EmpId"
                          filter={true}
                          placeholder="Choose..."
                          checkmark={true}
                          highlightOnSelect={false}
                        />
                        {errors[`${index}-DefaultAssignment`] && (
                          <div className="invalid-feedback">
                            {errors[`${index}-DefaultAssignment`]}
                          </div>
                        )}
                      </td>

                      <td>
                        <>
                          <img
                            src="/images/org-img/profile/close.png"
                            title="Cancel"
                            className="editactions me-2"
                            style={{ width: "17px" }}
                            onClick={cancelOrgWfh}
                          />

                          <img
                            src="/images/org-img/profile/check.png"
                            title="Confirm"
                            onClick={() => {
                              const item = empReqDefaultAssignment[index];
                              EmpRequestDefaultAssignmentForm.setValues({
                                CategoryId: item.CategoryId,
                                SubCategoryId: item.SubCategoryId,
                                DefaultAssignment: item.DefaultAssignment,
                                Id: item.Id ?? 0,
                                CreatedDate:
                                  item.CreatedDate ?? new Date().toISOString(),
                              });
                              if (validateRequestDefaultAssign(item, index)) {
                                EmpRequestDefaultAssignmentForm.handleSubmit();
                                setEditIndex(null);
                              }
                            }}
                            className="editactions"
                            style={{ width: "17px" }}
                          />
                        </>
                      </td>
                    </>
                  ) : (
                    <>
                      <td>{data?.CategoryName}</td>
                      <td>{data?.SubCategoryName}</td>
                      <td>{data?.defaultAssignmentName}</td>

                      <td className="">
                        <button
                          disabled={editIndex != null}
                          className="editactions me-2"
                          onClick={() => handleEditClick(index)}
                        >
                          <img
                            src="/images/tickets/edit-ico.svg"
                            className=""
                            title="Edit"
                          />
                        </button>

                        <button
                          className="editactions"
                          title="Delete"
                          data-bs-toggle="modal"
                          data-bs-target="#delete-emp-req-default-assignment"
                          onClick={() => {
                            handleEmpReqCategory(data?.Id);
                          }}
                        >
                          <img
                            src="/images/tickets/delete.svg"
                            className=""
                            title="Delete"
                          />
                        </button>
                      </td>
                    </>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="modal fade " id="delete-emp-req-default-assignment">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content delete-holiday">
              <div className="modal-header">
                <img
                  src="/images/org-img/leave/popup-backimg.png"
                  className="backimg"
                />
                <div className="img">
                  <img src="/images/org-img/leave/trash.png" />
                </div>
              </div>
              <div className="modal-body text-center">
                <strong className="modal-title">Are you sure?</strong>
                {/* <p>{deleteContent}</p> */}
                <p>
                  Do you really want to delete this Employee Request Default
                  Assignment?
                </p>
              </div>
              <div className="modal-footer m-auto">
                <button
                  type="button"
                  className="cancelbtn-click"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="deletebtn-click"
                  data-bs-dismiss="modal"
                  onClick={() => DeleteOrgEmpRequestDefaultAssignment()}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isLoading ? (
        <Suspense>
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}
    </div>
  );
};
export default EmployeeRequestDefaultAssignment;
